module.exports = __webpack_public_path__ + "static/media/arrowBack.26667b27.svg";